module.exports = __webpack_public_path__ + "static/media/fb-icon--light-blue.325075ef.svg";